import { MoveFocusInside } from 'react-focus-on';
import { useModalContentManager } from '@provider/notifier';
import { Button } from '@ui/kit';
import { CircledPlusIcon, FloppyIcon } from '@ui/kit/icons';
import { modal, heading, text, buttonsWrapper } from './_shared.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const makeUpdateRevisionModalConfig = revision => ({
  theme: "dialog",
  className: modal,
  content: /*#__PURE__*/jsx(Modal, {
    revision: revision
  })
});
function Modal(props) {
  const manager = useModalContentManager();
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsxs("h1", {
      className: heading,
      children: ["Vil du gemme \xE6ndringer til \u2018", props.revision.name, "\u2019?"]
    }), /*#__PURE__*/jsxs("p", {
      className: text,
      children: ["Hvis du gemmer, overskriver du den eksisterende version med de nye \xE6ndringer og versionen bliver opdateret hos de elever, du tidligere har delt med.", /*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsx("br", {}), "Du kan ogs\xE5 gemme dine \xE6ndringer som en ny version."]
    }), /*#__PURE__*/jsxs("div", {
      className: buttonsWrapper,
      children: [/*#__PURE__*/jsx(Button, {
        theme: "secondary",
        icon: /*#__PURE__*/jsx(CircledPlusIcon, {}),
        onClick: () => manager.onDismiss("create-new"),
        children: "Opret ny version"
      }), /*#__PURE__*/jsx(MoveFocusInside, {
        children: /*#__PURE__*/jsx(Button, {
          theme: "primary",
          icon: /*#__PURE__*/jsx(FloppyIcon, {}),
          onClick: () => manager.onDismiss("save"),
          children: "Gem \xE6ndringer"
        })
      })]
    })]
  });
}

export { makeUpdateRevisionModalConfig };
//# sourceMappingURL=update.js.map
